import { combineReducers } from "redux";
import appReducer from "Reducers/appReducer";
import localeReducer from "Reducers/localeReducer";
import userReducer from "Reducers/userReducer";
import productReducer from "Reducers/productReducer";
import cartReducer from "Reducers/cartReducer";
import orderReducer from "Reducers/orderReducer";
import finalFormReducer from 'Common/finalFormDuck'

const combinedReducer = combineReducers({
  app: appReducer,
  locale: localeReducer,
  user: userReducer,
  products: productReducer,
  form: finalFormReducer, //must use 'form' as the key name
  cart: cartReducer,
  order: orderReducer
});

const rootReducer = (state, action) => {
  if(action.type === 'RESET') {
    state = undefined;
    // state = {...state, user: undefined, form: undefined, authStatus: false,token: undefined}
  }
  return combinedReducer(state, action);
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/rootReducer.js